<template>
  <div class="tipModal">
    <artmisads-modal
      v-model:open="visible"
      title="Notice"
      okText="Leave"
      cancel-text="Cancel"
      @ok="handleConfirm"
      @cancel="handleCancel"
    >
     
        <div class="modal-content">
          <p>
            Your changes are not saved. Leaving this page will discard all unsaved configurations. Are you sure you want to leave?
          </p>
        </div>
     
    </artmisads-modal>
  </div>
</template>
<script setup>
import { ref, defineExpose,defineEmits } from 'vue'

const visible = ref(false)
const content = ref('')
const confirmText = ref('Leave')
const cancelText = ref('Cancel')
const emit = defineEmits(['confirm', 'cancel'])
const handleCancel = () => {
  visible.value = false
  emit('cancel')
}
const handleConfirm = () => {
  visible.value = false
  emit('confirm')
}
const showModal = () => {
  visible.value = true
}
defineExpose({
  showModal
})
</script>
<style scoped lang="less">
.modal-content {
  font-family: Sora;
  font-weight: 500;
  font-size: 18px;
  color: #0F0629;
}
</style>